import { Swipers } from './swipers.js';

export const initSwiper = function() {

  Swipers.initCatalog(document.querySelectorAll('[data-slider-catalog="slider"]'));
  Swipers.initIntro(document.querySelector('[data-slider-intro="slider"]'));
  Swipers.initBrands(document.querySelector('[data-slider-brands="slider"]'));
  Swipers.initFive(document.querySelectorAll('[data-slider-goods="slider-five"]'));
  Swipers.initFour(document.querySelectorAll('[data-slider-goods="slider-four"]'));
  Swipers.initThree(document.querySelectorAll('[data-slider="slider-3"]'));
  Swipers.initThreeCenter(document.querySelector('[data-slider="slider-3-center"]'));

  if (window.appConfig.breakpointTablet <= window.innerWidth) {
    Swipers.initOnlyDesktop(document.querySelectorAll('[data-slider-desktop="slider"]'));
  }

  if (window.appConfig.breakpointDeskTop >= window.innerWidth) {
    Swipers.initOnlyMobile(document.querySelectorAll('[data-slider-mobile="slider"]'));
  }

  Swipers.initMainBrands(document.querySelector('[data-main-brands="slider"]'));
  Swipers.initThumb(document.querySelector('[data-slider="slider-thumb"]'));

  window.Swipers = Swipers;
  //   Swiper.End
};
